<template>
  <el-dialog
    title="查看付款计划"
    :visible.sync="dialogVisible"
    width="700px"
    :close-on-click-modal="false"
    @close="handleClose"
    class="view-dialog"
    top="10vh"
  >
    <div class="view-dialog-content">
      <el-descriptions :column="2" border size="medium">
        <!-- 第1行：房屋地址（占2列） -->
        <el-descriptions-item label="房屋地址" :span="2">
          {{ viewData.房屋地址 || '-' }}
        </el-descriptions-item>

        <!-- 第2行：合同起始日 + 合同到期日 -->
        <el-descriptions-item label="合同起始日">
          {{ formatTimestamp(viewData.合同起始日) }}
        </el-descriptions-item>
        <el-descriptions-item label="合同到期日">
          {{ formatTimestamp(viewData.合同到期日) }}
        </el-descriptions-item>

        <!-- 第3行：房东 + 状态 -->
        <el-descriptions-item label="房东">
          {{ viewData.房东 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="getStatusType(viewData.状态)" size="small">
            {{ viewData.状态 || '-' }}
          </el-tag>
        </el-descriptions-item>

        <!-- 第4行：预计付款日期 + 预计付款金额 + 第几次付款 -->
        <el-descriptions-item label="预计付款日期">
          {{ formatTimestamp(viewData.付款日期) }}
        </el-descriptions-item>
        <el-descriptions-item label="预计付款金额">
          {{ viewData.付款金额 ? `¥${viewData.付款金额}` : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="第几次付款">
          {{ viewData.第几次付款 || '-' }}
        </el-descriptions-item>

        <!-- 第5行：支付户名 + 银行卡号 + 开户行 -->
        <el-descriptions-item label="支付户名">
          {{ viewData.支付户名 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="银行卡号">
          {{ viewData.银行卡号 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="开户行">
          {{ viewData.开户行 || '-' }}
        </el-descriptions-item>

        <!-- 第6行：备注（占2列） -->
        <el-descriptions-item label="备注" :span="2">
          {{ viewData.备注 || '-' }}
        </el-descriptions-item>

        <!-- 第7行：实际付款时间 + 实际付款金额 -->
        <el-descriptions-item v-if="viewData.实际付款时间" label="实际付款时间">
          {{ formatTimestamp(viewData.实际付款时间) }}
        </el-descriptions-item>
        <el-descriptions-item v-if="viewData.实际付款金额" label="实际付款金额">
          {{ viewData.实际付款金额 ? `¥${viewData.实际付款金额}` : '-' }}
        </el-descriptions-item>

        <!-- 第8行：退回原因（占2列） -->
        <el-descriptions-item label="退回原因" :span="2">
          {{ viewData.退回原因 || '-' }}
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ViewDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      dialogVisible: this.visible,
      viewData: {}
    }
  },

  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val && this.rowData) {
        this.initData()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },

  methods: {
    initData() {
      if (!this.rowData) return
      this.viewData = { ...this.rowData }
    },

    formatTimestamp(timestamp) {
      if (!timestamp) return '-'
      let ts = timestamp
      const str = String(ts)
      if (str.length === 10) {
        ts = ts * 1000
      }
      const date = new Date(ts)
      if (isNaN(date.getTime())) {
        return '-'
      }
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    getStatusType(status) {
      const map = {
        '待付': 'danger',
        '已付': 'success',
        '已中止': 'info',
        '待审核': 'warning'
      }
      return map[status] || 'info'
    },

    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.view-dialog /deep/ .el-dialog {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.view-dialog /deep/ .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 20px 20px 10px 20px;
}

.view-dialog /deep/ .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding: 12px 20px;
}

.view-dialog-content {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;
}

.view-dialog-content::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.view-dialog-content::-webkit-scrollbar-track {
  background: #f0f2f5;
  border-radius: 3px;
}

.view-dialog-content::-webkit-scrollbar-thumb {
  background: #c1c7cd;
  border-radius: 3px;
}

.view-dialog-content::-webkit-scrollbar-thumb:hover {
  background: #a8b0b8;
}

.view-dialog-content {
  scrollbar-width: thin;
  scrollbar-color: #c1c7cd #f0f2f5;
}

.view-dialog .el-descriptions-item__label {
  width: 140px;
}
</style>